export const SET_PROFILE_AVATAR = 'SET_PROFILE_AVATAR';
